import React, { PureComponent } from 'react'

class Footer extends PureComponent {
  render() {
    return <footer className="rka-footer">Rokka &copy; 2018</footer>
  }
}

export default Footer
